import { getTimeString } from '../../../backend/utils/getTimeString';
import { useMissionsTranslation } from '../../../ui/hooks';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { Box, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import React from 'react';
import { DeniedNoShowHoursStatus } from '../time-tracking/components/DeniedNoShowHoursStatus';
export const TimeTrackingStatus = ({ status, time }) => {
    const { t } = useMissionsTranslation();
    switch (status) {
        case 'deniedNoShow':
            return React.createElement(DeniedNoShowHoursStatus, null);
        case 'pending':
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: (theme) => theme.palette.grey[700] }, "data-test": 'pending-hours' },
                React.createElement(TimelapseIcon, { fontSize: 'small', color: 'warning' }),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mt: 0.25 } },
                    React.createElement(Typography, { variant: 'subtitle2', sx: { mr: 0.5 } }, getTimeString(time !== null && time !== void 0 ? time : 0, true)),
                    React.createElement(Typography, { component: 'span', variant: 'body2' }, t('shifts.adminTimeTracking.pending')))));
        case 'approved':
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: (theme) => theme.palette.grey[700] }, "data-test": 'approved-hours' },
                React.createElement(CheckCircleIcon, { fontSize: 'small', sx: { color: green[500] } }),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mt: 0.25 } },
                    React.createElement(Typography, { variant: 'subtitle2', sx: { mr: 0.5 } }, getTimeString(time !== null && time !== void 0 ? time : 0, true)),
                    React.createElement(Typography, { component: 'span', variant: 'body2' }, t('shifts.adminTimeTracking.approved')))));
        case 'deniedInaccurate':
        case 'addHours':
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: (theme) => theme.palette.grey[700] }, "data-test": 'no-hours' },
                React.createElement(RemoveCircleIcon, { fontSize: 'small', color: 'warning' }),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' } },
                    React.createElement(Typography, { variant: 'body2' }, t('shifts.adminTimeTracking.noHours')))));
        default:
            return null;
    }
};
